import { useState, useContext } from "react";
import axios from "axios";
import { useForm, SubmitHandler, FieldValues } from "react-hook-form";
import { useNavigate } from "react-router";
// mui
import { TextField, TextareaAutosize, Button } from "@mui/material";
// components
import BasePanel from "src/components/UI/Shared/BasePanel";
import SharedHandler from "src/components/UI/Shared/handler";
import user from "src/components/UI/Shared/user";
// config

import { RESPONSE_STATUS } from "src/config/service";
// assets
import styles from "src/components/UI/Contact/assets/scss/contact-us.module.scss";
// redux
import { useDispatch, useSelector } from "react-redux";
import { appActions } from "src/store/store";

interface ContactUsProps {}
const ContactUs = ({}: ContactUsProps) => {
  const dispatch = useDispatch();
  const optionalParam = useSelector((state: any) => state.app.optionalParam);
  const navigate = useNavigate();

  const [open, setOpen] = useState(true);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    mode: "onChange",
  });

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason !== "backdropClick") {
      // setOpenToolbox(false);
      setOpen(false);
      navigate("..");
    }
  };
  const behaviour = async (returned: any) => {
    if (returned.flag === "TRACKING") {
      if (returned.message[0] === RESPONSE_STATUS.BLOCKED) {
        await dispatch(
          appActions.setNotification({
            severity: "error",
            message: "You can't use this service today anymore.",
            open: true,
          })
        );
      } else if (returned.message[1]) {
        dispatch(
          appActions.setTrackingData({
            serviceStatus: returned.message[0],
            captcha: returned.message[1],
          })
        );
      } else {
        dispatch(
          appActions.setTrackingData({ serviceStatus: returned.message[0] })
        );
      }
    } else if (returned.flag === "SUCCESS") {
      dispatch(
        appActions.setNotification({
          open: true,
          message: "Email sent successfully.",
          severity: "success",
        })
      );
      setValue("name", "");
      setValue("email", "");
      setValue("message", "");
    } else if (returned.flag === "ERROR") {
      dispatch(
        appActions.setNotification({
          open: true,
          message:
            returned.message[0] && returned.message[0] !== ""
              ? returned.message
              : "Can't send message.",
          severity: "error",
        })
      );
    }
  };
  const handleSubmit_: SubmitHandler<FieldValues> = async (data) => {
    const apiURL = process.env.REACT_APP_API_URL || "";
    const ip = user.parseUserIp();

    let endpointUrl = "contact/";
    const timestamp = new Date().toISOString();
    const signature = SharedHandler.signRequest(
      "/" + endpointUrl,
      "POST",
      timestamp
    );

    const formData = new FormData();
    formData.append("ip", ip);
    formData.append("name", data.name);
    formData.append("user_email", data.email);
    formData.append("message", data.message);

    dispatch(appActions.setPreviousNavigation("/contact-us"));
    let returned = { flag: "", message: [""] };
    if (optionalParam === "0") {
      endpointUrl = endpointUrl + `?reset=0`;
    }
    try {
      await axios
        .post(apiURL + endpointUrl, formData, {
          headers: {
            "X-Signature": signature,
            "X-Timestamp": timestamp,
          },
        })

        .then((response) => {
          const response_data = SharedHandler.decodeResponse(response);

          if (response_data.verification_status) {
            if (response_data.captcha) {
              returned = {
                flag: "TRACKING",
                message: [
                  response_data.verification_status,
                  response_data.captcha,
                ],
              };
            } else {
              returned = {
                flag: "TRACKING",
                message: [response_data.verification_status],
              };
            }
          } else if (response.data.error) {
            returned = { flag: "ERROR", message: response.data.error };
          } else if (response.data === "Email sent successfully.") {
            returned = { flag: "SUCCESS", message: response.data };
          }
        })
        .catch((error) => {
          returned = { flag: "ERROR", message: error.message };
        });
    } catch (error) {
      returned = { flag: "ERROR", message: [""] };
    }
    await behaviour(returned);
  };
  return (
    <BasePanel openModal={open} onClose={handleClose} panelName={"Contact us"}>
      <div className={styles.content}>
        <TextField
          {...register("name", {
            required: "Name is required.",
          })}
          name="name"
          label="Name"
          variant="outlined"
          error={!!errors.name}
          helperText={errors.name?.message?.toString()}
          className={styles.textField}
        />
        <TextField
          {...register("email", {
            required: "Email address is required.",
            pattern: {
              value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i,
              message: "Invalid email format.",
            },
          })}
          name="email"
          label="Email"
          variant="outlined"
          error={!!errors.email}
          helperText={errors.email?.message?.toString()}
          className={styles.textField}
        />
        <TextareaAutosize
          maxLength={500}
          {...register("message")}
          placeholder="Message"
          className={styles.txtArea}
        />
        <div className={styles.buttons}>
          <Button
            variant="outlined"
            onClick={handleSubmit(handleSubmit_)}
            className={`${styles.button}`}
            disabled={
              Boolean(errors.name) ||
              Boolean(errors.message) ||
              Boolean(errors.email)
            }
          >
            Submit
          </Button>
          <Button
            variant="outlined"
            onClick={handleClose}
            className={`${styles.button}  `}
          >
            Cancel
          </Button>
        </div>
      </div>
    </BasePanel>
  );
};
export default ContactUs;
